module.exports = __webpack_public_path__ + "img/loader.6fc3b313.svg";